import { render } from "./BtnBack.vue?vue&type=template&id=19307241"
import script from "./BtnBack.vue?vue&type=script&lang=js"
export * from "./BtnBack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__